import FieldOfAreaList from '../../components/field-of-area-list';

import {
	type FieldOfAreaListAllFragment,
	fieldOfAreaListFromFieldOfAreaListAllSection,
} from './query';

type Props = {
	data: FieldOfAreaListAllFragment;
	fullWidth?: boolean;
	anchorHeadings?: boolean;
	insideToc?: boolean;
};

export const FieldOfAreaListAllContainer = ({
	data,
	fullWidth,
	anchorHeadings,
	insideToc,
}: Props) => {
	const fieldOfAreas = fieldOfAreaListFromFieldOfAreaListAllSection(data);

	return (
		<FieldOfAreaList
			fieldOfAreas={fieldOfAreas}
			heading={data.heading}
			anchorHeadings={anchorHeadings}
			options={{
				fullWidth,
				...data.contentBlockOptions,
			}}
			insideToc={insideToc}
			showDetails={data.showDetails}
		/>
	);
};
